import { render } from "./active_filter.components.vue?vue&type=template&id=b0984ff2&ts=true"
import script from "./active_filter.components.vue?vue&type=script&lang=ts"
export * from "./active_filter.components.vue?vue&type=script&lang=ts"

import exportComponent from "/home/seb/_git-wsl/inv-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__